import { defineStore } from 'pinia'

export const useCacheKeysStore = defineStore('cacheKeys', () => {
  const expirationTimes = ref<{ [key: string]: Date }>({})

  function setFetchedTime(key: string, expirationTime: Date) {
    expirationTimes.value[key] = expirationTime
  }

  function getFetchedTime(key: string) {
    return expirationTimes.value[key]
  }

  return {
    expirationTimes,
    setFetchedTime,
    getFetchedTime,
  }
})
